(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[766],{

/***/ 44464:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Qi": function() { return /* reexport */ BaseProduct/* default */.Z; },
  "VN": function() { return /* reexport */ details_DetailsAddToCartButton; },
  "O0": function() { return /* reexport */ details_DetailsChooseToppings; },
  "Tc": function() { return /* reexport */ details_DetailsChooseVariation; },
  "Gm": function() { return /* reexport */ details_DetailsSpecialInstructions; },
  "f4": function() { return /* reexport */ details_ProductDetails; },
  "qN": function() { return /* reexport */ ProductImage/* default */.Z; },
  "Cd": function() { return /* reexport */ product_ProductItem; },
  "Sh": function() { return /* reexport */ (Product_module_default()); }
});

// UNUSED EXPORTS: MenuItem, MenuList

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/styles/useTheme.js
var useTheme = __webpack_require__(8920);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/useMediaQuery/useMediaQuery.js
var useMediaQuery = __webpack_require__(63457);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/IconButton/IconButton.js
var IconButton = __webpack_require__(17812);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Button/Button.js
var Button = __webpack_require__(282);
// EXTERNAL MODULE: ./node_modules/@material-ui/icons/Add.js
var Add = __webpack_require__(63957);
// EXTERNAL MODULE: ./node_modules/@material-ui/icons/Remove.js
var Remove = __webpack_require__(10064);
// EXTERNAL MODULE: ./utils/helpers.ts + 37 modules
var helpers = __webpack_require__(22412);
// EXTERNAL MODULE: ./components/product/details/ProductDetails.module.scss
var ProductDetails_module = __webpack_require__(3861);
var ProductDetails_module_default = /*#__PURE__*/__webpack_require__.n(ProductDetails_module);
;// CONCATENATED MODULE: ./components/product/details/DetailsAddToCartButton.tsx







var DetailsAddToCartButton = function(param) {
    var state = param.state, isValid = param.isValid, isSoldOut = param.isSoldOut, isDialog = param.isDialog, handleIncrementQty = param.handleIncrementQty, handleDecrementQty = param.handleDecrementQty;
    var theme = (0,useTheme/* default */.Z)();
    var isSmallScreen = (0,useMediaQuery/* default */.Z)(theme.breakpoints.down("xs"));
    var disabled = state.quantity === 1;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: isDialog ? (ProductDetails_module_default()).sticky__footer : (ProductDetails_module_default()).footer,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (ProductDetails_module_default()).fab__container,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton/* default */.Z, {
                        "aria-label": "add",
                        size: isSmallScreen ? "small" : "medium",
                        style: {
                            backgroundColor: "#eaeaea"
                        },
                        onClick: handleDecrementQty,
                        disabled: disabled,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Remove/* default */.Z, {
                            color: disabled ? "disabled" : "action"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "mh05 noselect font__x__large",
                        children: state.quantity
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton/* default */.Z, {
                        "aria-label": "remove",
                        size: isSmallScreen ? "small" : "medium",
                        style: {
                            backgroundColor: "#eaeaea"
                        },
                        onClick: handleIncrementQty,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Add/* default */.Z, {
                            color: "primary"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (ProductDetails_module_default()).cart__btn,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Button/* default */.Z, {
                    type: "submit",
                    variant: "contained",
                    size: "large",
                    style: {
                        minHeight: 50
                    },
                    color: isValid ? "primary" : "default",
                    fullWidth: true,
                    disabled: isSoldOut,
                    children: [
                        isSoldOut ? "Stoc epuizat" : "Adauga in cos",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: (ProductDetails_module_default()).price,
                            children: state.price > 0 && (0,helpers/* formatPrice */.T4)(state.totalPrice * state.quantity)
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                style: {
                    scrollMarginBlockEnd: 100
                }
            })
        ]
    });
};
/* harmony default export */ var details_DetailsAddToCartButton = (DetailsAddToCartButton);

// EXTERNAL MODULE: ./node_modules/formik/dist/formik.esm.js + 121 modules
var formik_esm = __webpack_require__(82175);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/ListItemText/ListItemText.js
var ListItemText = __webpack_require__(95757);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Typography/Typography.js
var Typography = __webpack_require__(22318);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/ListItem/ListItem.js
var ListItem = __webpack_require__(50998);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Checkbox/Checkbox.js + 3 modules
var Checkbox = __webpack_require__(80797);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Radio/Radio.js + 5 modules
var Radio = __webpack_require__(24691);
// EXTERNAL MODULE: ./node_modules/@material-ui/icons/esm/ExpandMore.js
var ExpandMore = __webpack_require__(73099);
;// CONCATENATED MODULE: ./components/product/details/DetailsChooseToppings.tsx







var MAX_OPTIONS_COUNT = 5;
var DetailsChooseToppings = function(param) {
    var productVariation = param.productVariation, topping = param.topping, errors = param.errors, onToppingsChange = param.onToppingsChange;
    var ref, ref1, ref2;
    var multiple = (0,helpers/* isMultiple */.EC)(topping);
    var ref3 = (0,react.useState)(false), expanded = ref3[0], setExpanded = ref3[1];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        id: topping === null || topping === void 0 ? void 0 : topping.name,
        className: (ProductDetails_module_default()).topping__category__scroll,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ListItemText/* default */.Z, {
                className: (ProductDetails_module_default()).topping__category,
                primary: topping === null || topping === void 0 ? void 0 : topping.name,
                secondary: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                    variant: "body2",
                    color: "textSecondary",
                    style: errors[topping.name] ? {
                        fontWeight: 700,
                        color: "#fa755a"
                    } : null,
                    children: (0,helpers/* toppingCategoryText */.y6)(topping)
                })
            }),
            (ref2 = (ref1 = (ref = topping.options) === null || ref === void 0 ? void 0 : ref.sort(function(o1, o2) {
                return o1.sortId - o2.sortId;
            })) === null || ref1 === void 0 ? void 0 : ref1.slice(0, expanded ? 100 : MAX_OPTIONS_COUNT)) === null || ref2 === void 0 ? void 0 : ref2.map(function(option) {
                var disabled = option.is_sold_out || (0,helpers/* isMultipleOptionsListDisabled */.oz)(productVariation, topping, option);
                return /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                    onChange: onToppingsChange(topping, option),
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ListItem/* default */.Z, {
                        button: true,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(formik_esm/* Field */.gN, {
                                name: topping.name,
                                value: option.name,
                                type: multiple ? "checkbox" : "radio",
                                as: multiple ? Checkbox/* default */.Z : Radio/* default */.Z,
                                multiple: multiple,
                                disabled: disabled
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ListItemText/* default */.Z, {
                                className: "between",
                                primary: option.name,
                                secondary: option.is_sold_out ? "indisponibil" : option.price > 0 && "+".concat((0,helpers/* formatPrice */.T4)(option.price)),
                                style: {
                                    color: disabled ? "darkgray" : "black"
                                }
                            })
                        ]
                    })
                }, option.id);
            }),
            topping.options.length > 6 && !expanded && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "center-l ml1 hover",
                onClick: function() {
                    return setExpanded(true);
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton/* default */.Z, {
                        "aria-label": "expand",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ExpandMore/* default */.Z, {})
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                        color: "secondary",
                        children: [
                            "Arata mai multe (",
                            topping.options.length - MAX_OPTIONS_COUNT,
                            ")"
                        ]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var details_DetailsChooseToppings = (DetailsChooseToppings);

;// CONCATENATED MODULE: ./components/product/details/DetailsChooseVariation.tsx






var DetailsChooseVariation = function(param) {
    var product = param.product, errors = param.errors, hasPriceVariations = param.hasPriceVariations, onVariationChange = param.onVariationChange;
    if (!hasPriceVariations) return null;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ListItemText/* default */.Z, {
                id: "name",
                className: (ProductDetails_module_default()).topping__category,
                primary: "Alege varianta",
                secondary: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                    className: errors.name ? "error" : "",
                    children: "Necesar"
                })
            }),
            product.product_variations.map(function(variation, idx) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                    onChange: onVariationChange(idx),
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ListItem/* default */.Z, {
                        button: true,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(formik_esm/* Field */.gN, {
                                name: "name",
                                type: "radio",
                                value: variation.name,
                                as: Radio/* default */.Z
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ListItemText/* default */.Z, {
                                className: "between",
                                primary: variation.name,
                                secondary: (0,helpers/* formatPrice */.T4)(variation.price)
                            })
                        ]
                    })
                }, variation.id);
            })
        ]
    });
};
/* harmony default export */ var details_DetailsChooseVariation = (DetailsChooseVariation);

// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/TextField/TextField.js + 3 modules
var TextField = __webpack_require__(8101);
;// CONCATENATED MODULE: ./components/product/details/DetailsSpecialInstructions.tsx




var DetailsSpecialInstructions = function(param) {
    var onAddSpecialInstructions = param.onAddSpecialInstructions;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (ProductDetails_module_default()).special_instructions_container,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ListItemText/* default */.Z, {
                className: (ProductDetails_module_default()).topping__category,
                primary: "Instructiuni speciale",
                secondary: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                    children: "Vom face tot posibilul sa le indeplnim"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(TextField/* default */.Z, {
                fullWidth: true,
                variant: "outlined",
                onChange: onAddSpecialInstructions,
                placeholder: "Instructiuni...",
                multiline: true,
                minRows: 3,
                maxRows: 3,
                style: {
                    padding: "1em"
                }
            })
        ]
    });
};
/* harmony default export */ var details_DetailsSpecialInstructions = (DetailsSpecialInstructions);

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
;// CONCATENATED MODULE: ./reducers/variationReducer.ts
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}

var initialState = {
    id: "",
    name: "",
    price: 0,
    totalPrice: 0,
    quantity: 1,
    topping_ids: [],
    choices: [],
    toppings: [],
    special_requests: ""
};
var updatePrice = function(state) {
    return state.choices.reduce(function(acc, topping) {
        return acc + topping.options.reduce(function(total, option) {
            return total + option.price;
        }, 0);
    }, state.price);
};
var handleAdd = function(state, payload) {
    var topping = payload.topping, option = payload.option;
    var multiple = (0,helpers/* isMultiple */.EC)(topping);
    var alreadyAddedTopping = state.choices.some(function(t) {
        return t.id === topping.id;
    });
    var updateChoices = function() {
        if (multiple) {
            // checkbox, multiple
            state.choices.map(function(t) {
                return t.id === topping.id ? t.options.push(option) : t;
            });
        } else {
            // radio, single,
            state.choices.map(function(t) {
                return t.id === topping.id ? t.options.splice(0, t.options.length, option) // replace with the new radio value
                 : t;
            });
        }
    };
    var addNewChoice = function() {
        state.choices.push(_objectSpread({}, topping, {
            options: topping.options.filter(function(opt) {
                return opt.id === option.id;
            })
        }));
    };
    alreadyAddedTopping ? updateChoices() : addNewChoice();
    return _objectSpread({}, state, {
        choices: state.choices,
        totalPrice: updatePrice(state)
    });
};
var handleRemove = function(state, payload) {
    var removeOption = function(t) {
        return _objectSpread({}, t, {
            options: t.options.filter(function(opt) {
                return opt.id !== payload.option.id;
            })
        });
    };
    return _objectSpread({}, state, {
        choices: state.choices.map(function(t) {
            return t.id === payload.topping.id ? removeOption(t) : t;
        }).filter(function(t) {
            return t.options.length !== 0;
        }),
        totalPrice: state.totalPrice - payload.option.price
    });
};
var variationReducer = function(state, action) {
    switch(action.type){
        case "CHANGE_VARIATION":
            return _objectSpread({}, action.payload.product_variation, {
                quantity: state.quantity || 1,
                totalPrice: action.payload.product_variation.price,
                toppings: action.payload.toppings,
                choices: []
            });
        case "ADD":
            return handleAdd(state, action.payload);
        case "REMOVE":
            return handleRemove(state, action.payload);
        case "SPECIAL_REQUESTS":
            return _objectSpread({}, state, {
                special_requests: action.payload.text
            });
        case "DECREMENT_QTY":
            return state.quantity === 1 ? state : _objectSpread({}, state, {
                quantity: state.quantity - 1
            });
        case "INCREMENT_QTY":
            return _objectSpread({}, state, {
                quantity: state.quantity + 1
            });
        case "CLEAR":
            return initialState;
        default:
            return state;
    }
};

// EXTERNAL MODULE: ./node_modules/yup/es/index.js + 25 modules
var es = __webpack_require__(74231);
;// CONCATENATED MODULE: ./schemas/productValidationSchema.ts


var productValidationSchema = function(state, hasPriceVariations) {
    var ref;
    var schema = {};
    if (hasPriceVariations) {
        schema.name = (0,es/* string */.Z_)().required("Necesar");
    }
    (ref = state.toppings) === null || ref === void 0 ? void 0 : ref.forEach(function(topping) {
        var min = topping.quantity_minimum;
        var max = topping.quantity_maximum === 0 ? topping.options.length : topping.quantity_maximum;
        var multipleSchema = (0,es/* array */.IX)().min(min, "Necesar, minim ".concat(min)).max(max, "Alege maxim ".concat(max));
        var required = (0,helpers/* isRequired */.q9)(topping);
        var multiple = (0,helpers/* isMultiple */.EC)(topping);
        schema[topping.name] = multiple ? required ? multipleSchema.required("necesar") : multipleSchema.nullable() : required // single choice - radio type
         ? (0,es/* string */.Z_)().required("Alege 1") : (0,es/* string */.Z_)().nullable();
    });
    return (0,es/* object */.Ry)().shape(schema);
};

// EXTERNAL MODULE: ./APIs/analytics.ts
var analytics = __webpack_require__(57742);
// EXTERNAL MODULE: ./components/common/index.ts + 28 modules
var common = __webpack_require__(26075);
// EXTERNAL MODULE: ./context/index.ts + 10 modules
var context = __webpack_require__(64648);
;// CONCATENATED MODULE: ./components/product/details/ProductDetails.tsx
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function ProductDetails_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function ProductDetails_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            ProductDetails_defineProperty(target, key, source[key]);
        });
    }
    return target;
}












var ProductDetails = function(props) {
    var ref2;
    var theme = (0,useTheme/* default */.Z)();
    var isLargeScreen = (0,useMediaQuery/* default */.Z)(theme.breakpoints.up("xs"));
    var product = props.product;
    var ref1 = (0,react.useReducer)(variationReducer, initialState), state = ref1[0], dispatch = ref1[1];
    var cart = (0,context/* useCart */.jD)();
    var hasPriceVariations = ((ref2 = product.product_variations) === null || ref2 === void 0 ? void 0 : ref2.length) > 1;
    var handleChangeVariation = (0,react.useCallback)(function() {
        var _ref = _asyncToGenerator(runtime_default().mark(function _callee(index) {
            var ref, toppings, selectedVariation;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        ;
                        toppings = [];
                        selectedVariation = product.product_variations[index];
                        selectedVariation === null || selectedVariation === void 0 ? void 0 : (ref = selectedVariation.topping_ids) === null || ref === void 0 ? void 0 : ref.map(function(toppingId) {
                            return props.toppings.map(function(t) {
                                return t.id === toppingId ? toppings.push(t) : t;
                            });
                        });
                        dispatch({
                            type: "CHANGE_VARIATION",
                            payload: {
                                product_variation: selectedVariation,
                                toppings: toppings
                            }
                        });
                        (0,analytics/* analyticsItemDetailsVariation */.lo)(product, selectedVariation);
                    case 6:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function(index) {
            return _ref.apply(this, arguments);
        };
    }(), [
        props.toppings,
        product.product_variations
    ]);
    (0,react.useEffect)(function() {
        if (!hasPriceVariations) handleChangeVariation(0);
        return function() {
            dispatch({
                type: "CLEAR"
            });
        };
    }, [
        hasPriceVariations,
        handleChangeVariation
    ]);
    var onVariationChange = function(index) {
        return function(e) {
            e.preventDefault();
            handleChangeVariation(index);
        };
    };
    var onToppingsChange = function(topping, option) {
        return function(e) {
            e.preventDefault();
            var checked = e.target.checked;
            dispatch({
                type: checked ? "ADD" : "REMOVE",
                payload: {
                    topping: topping,
                    option: option
                }
            });
        };
    };
    var onIncrementQty = function() {
        dispatch({
            type: "INCREMENT_QTY"
        });
    };
    var onDecrementQty = function() {
        dispatch({
            type: "DECREMENT_QTY"
        });
    };
    var onAddSpecialInstructions = function(e) {
        dispatch({
            type: "SPECIAL_REQUESTS",
            payload: {
                text: e.target.value
            }
        });
    };
    var onSubmit = function() {
        var updatedProduct = ProductDetails_objectSpread({}, product);
        updatedProduct.product_variations = [
            state
        ];
        cart.add(updatedProduct);
        if (isLargeScreen && cart.cartState.products.length === 0) {
            cart.setOpen(true);
        }
        props.onAddToCartClick();
        (0,analytics/* analyticsAddToCart */.cP)(updatedProduct);
    };
    var formikProductDetailsInitialValues = {
        id: "",
        price: 0,
        totalPrice: 0,
        name: state.name,
        quantity: 0,
        topping_ids: [],
        choices: props.choices,
        toppings: state.toppings,
        special_requests: ""
    };
    var titleStyle = {
        display: !props.isDialog || product.file_path ? "flex" : "none"
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductImage/* default */.Z, {
                product: product,
                size: "large"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                className: (ProductDetails_module_default()).title,
                style: titleStyle,
                children: product.name
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ListItemText/* default */.Z, {
                className: "ph1 light",
                secondary: product.description
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(formik_esm/* Formik */.J9, {
                initialValues: formikProductDetailsInitialValues,
                validationSchema: productValidationSchema(state, hasPriceVariations),
                onSubmit: onSubmit,
                validateOnMount: true,
                enableReinitialize: true,
                children: function(param) {
                    var values = param.values, errors = param.errors, isValid = param.isValid;
                    var ref;
                    /*#__PURE__*/ return (0,jsx_runtime.jsxs)(formik_esm/* Form */.l0, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(details_DetailsChooseVariation, {
                                hasPriceVariations: hasPriceVariations,
                                errors: errors,
                                product: product,
                                onVariationChange: onVariationChange
                            }),
                            (ref = values.toppings) === null || ref === void 0 ? void 0 : ref.map(function(topping) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(details_DetailsChooseToppings, {
                                    productVariation: values,
                                    topping: topping,
                                    errors: errors,
                                    onToppingsChange: onToppingsChange
                                }, topping.id);
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(details_DetailsSpecialInstructions, {
                                onAddSpecialInstructions: onAddSpecialInstructions
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(details_DetailsAddToCartButton, {
                                isSoldOut: product.is_sold_out,
                                state: state,
                                isValid: isValid,
                                handleIncrementQty: onIncrementQty,
                                handleDecrementQty: onDecrementQty,
                                isDialog: props.isDialog
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(common/* FormikFocusError */.v0, {})
                        ]
                    });
                }
            })
        ]
    });
};
/* harmony default export */ var details_ProductDetails = (ProductDetails);

// EXTERNAL MODULE: ./components/product/product/BaseProduct.tsx
var BaseProduct = __webpack_require__(19615);
// EXTERNAL MODULE: ./components/product/product/ProductImage.tsx
var ProductImage = __webpack_require__(97154);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Grid/Grid.js
var Grid = __webpack_require__(41749);
// EXTERNAL MODULE: ./node_modules/@material-ui/icons/esm/Share.js
var Share = __webpack_require__(22128);
;// CONCATENATED MODULE: ./components/product/product/ProductItem.tsx









var ProductItem = function(param) {
    var product = param.product, toppings = param.toppings;
    var alert = (0,context/* useAlert */.VY)();
    var ref = (0,react.useState)(false), open = ref[0], setOpen = ref[1];
    var toggle = function() {
        return setOpen(!open);
    };
    var ref1 = (0,react.useState)(false), isSolidAppbar = ref1[0], setIsSolidAppbar = ref1[1];
    var onClick = function() {
        setOpen(!open);
        if (open) (0,analytics/* analyticsSelectItem */.lK)(product);
    };
    var handleCopyToClipboard = function() {
        try {
            var url = "".concat(window.location.origin, "/").concat((0,helpers/* formattedProductLink */.Uj)(product));
            navigator.clipboard.writeText(url);
            alert.show("info", "Linkul a fost copiat in clipboard");
        } catch (error) {
            console.error(error);
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.Z, {
                item: true,
                xs: 12,
                md: 6,
                className: (Product_module_default()).product__divider,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(BaseProduct/* default */.Z, {
                    product: product,
                    onClick: onClick
                })
            }),
            open && /*#__PURE__*/ (0,jsx_runtime.jsx)(common/* CustomDialog */.QA, {
                open: open,
                onClose: onClick,
                position: !product.file_path ? "sticky" : "absolute",
                title: !product.file_path //no img
                 ? product.name : isSolidAppbar //img
                 ? product.name : null,
                rightAction: /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton/* default */.Z, {
                    edge: "end",
                    color: "inherit",
                    "aria-label": "share",
                    onClick: handleCopyToClipboard,
                    style: {
                        backgroundColor: "rgba(255,255,255,0.5)"
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Share/* default */.Z, {
                        color: "inherit"
                    })
                }),
                onScrollCapture: function(v) {
                    return setIsSolidAppbar(v > 230);
                },
                color: isSolidAppbar ? "inherit" : "transparent",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(details_ProductDetails, {
                    product: product,
                    toppings: toppings,
                    onAddToCartClick: toggle,
                    isDialog: true
                })
            })
        ]
    });
};
/* harmony default export */ var product_ProductItem = (ProductItem);

// EXTERNAL MODULE: ./components/product/menu/MenuItem.tsx
var MenuItem = __webpack_require__(1453);
// EXTERNAL MODULE: ./components/product/menu/MenuList.tsx
var MenuList = __webpack_require__(27369);
// EXTERNAL MODULE: ./components/product/Product.module.scss
var Product_module = __webpack_require__(3293);
var Product_module_default = /*#__PURE__*/__webpack_require__.n(Product_module);
;// CONCATENATED MODULE: ./components/product/index.ts













/***/ }),

/***/ 1453:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(41749);
/* harmony import */ var _components_product__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(44464);



var MenuItem = function(param) {
    var menu = param.menu, toppings = param.toppings;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "container-lg pt1",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                children: menu.name
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                container: true,
                spacing: 2,
                children: menu.products.map(function(product) {
                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_product__WEBPACK_IMPORTED_MODULE_1__/* .ProductItem */ .Cd, {
                        product: product,
                        toppings: toppings
                    }, product.id);
                })
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (MenuItem);


/***/ }),

/***/ 27369:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _MenuItem__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1453);


var MenuList = function(param) {
    var menus = param.menus, toppings = param.toppings;
    /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "white",
        children: menus === null || menus === void 0 ? void 0 : menus.map(function(menu) {
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("section", {
                // id={menu.name.replace(/ /g, '-').replace(/'/g, '').toLowerCase()}
                id: menu.name,
                className: "category-divider",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_MenuItem__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                    menu: menu,
                    toppings: toppings
                })
            }, menu.id);
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (MenuList);


/***/ }),

/***/ 19615:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _components_product__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(44464);
/* harmony import */ var _utils_helpers__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(22412);



var BaseProduct = function(param) {
    var product = param.product, onClick = param.onClick, _isDialog = param.isDialog, isDialog = _isDialog === void 0 ? true : _isDialog;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: _components_product__WEBPACK_IMPORTED_MODULE_1__/* .classes.product */ .Sh.product,
        onClick: onClick,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: _components_product__WEBPACK_IMPORTED_MODULE_1__/* .classes.title */ .Sh.title,
                children: [
                    isDialog ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                        children: product.name
                    }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h1", {
                        children: product.name
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                        children: product.description
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                        style: {
                            fontWeight: 500,
                            fontSize: "regular"
                        },
                        children: (0,_utils_helpers__WEBPACK_IMPORTED_MODULE_2__/* .formatPrice */ .T4)(product.product_variations[0].price)
                    }),
                    product.is_sold_out && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("small", {
                        children: "Stoc epuizat"
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_product__WEBPACK_IMPORTED_MODULE_1__/* .ProductImage */ .qN, {
                product: product,
                size: "small"
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (BaseProduct);


/***/ }),

/***/ 3861:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"sticky__footer":"ProductDetails_sticky__footer__y4Vo0","footer":"ProductDetails_footer__VbGgu","topping__category":"ProductDetails_topping__category__wBokd","topping__category__scroll":"ProductDetails_topping__category__scroll__aOO6g","title":"ProductDetails_title__yEmKp","cart__btn":"ProductDetails_cart__btn__qRSKE","price":"ProductDetails_price__o4et6","fab__container":"ProductDetails_fab__container__XBdBd","fab":"ProductDetails_fab__Q2_jU","special_instructions_container":"ProductDetails_special_instructions_container__ill6N"};

/***/ })

}]);